import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { logout as logoutService } from '../../services/authService';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const Sidebar = ({ activeComponent, setActiveComponent }) => {
    const { dispatch } = useAuth();
    const { state } = useAuth();
    const { user } = state;
    const navigate = useNavigate();
    const [openDialog, setOpenDialog] = useState(false);

    const handleLogoutClick = () => {
        setOpenDialog(true);
    };

    const handleConfirmLogout = () => {
        logoutService();
        dispatch({ type: 'LOGOUT' });

        const isAdmin = localStorage.getItem('adminToken'); // Check BEFORE calling logoutService
        setOpenDialog(false);
        if (isAdmin) {
            navigate('/admin-dashboard');
        } else {
            navigate('/login');
        }
    };


    const getInitials = (firstName, lastName) => {
        const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
        const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
        return `${firstInitial}${lastInitial}`;
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <aside className="w-full md:w-1/4 bg-white p-6 lg:pl-16">
            <div className="flex items-center mb-6">

                <div className="w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center">
                    {getInitials(user?.first_name, user?.last_name)}
                </div>
                {/* <img
                    src="https://e7.pngegg.com/pngimages/752/457/png-clipart-60x60-compact-disc-composer-vox-novus-artist-others-miscellaneous-angle.png"
                    className="w-16 rounded-full"
                    alt="Profile of [person's name]"
                /> */}
                <div className="p-2">
                    {/* <h2 className="font-bold ">User Profile</h2> */}
                    <h1 style={{ fontFamily: "Helvetica" }} className=" text-lg font-bold">{user?.first_name}</h1>
{/* 
                    <p className="text-gray-500">
                        <i className="fas fa-map-marker-alt"></i> India
                    </p> */}
                </div>
            </div>
            <nav>
                <h3 style={{ fontFamily: "Helvetica" }} className="text-gray-500 mb-4">Menu</h3>
                <ul>
                    <li
                        className={`mb-4 flex items-center cursor-pointer ${activeComponent === 'Profile' ? 'text-blue-600' : 'text-gray-700'}`}
                        onClick={() => setActiveComponent('Profile')}
                    >
                        <i className="fas fa-user-circle mr-2"></i> Profile
                    </li>
                    <li
                        className={`mb-4 flex items-center cursor-pointer ${activeComponent === 'Assessment' ? 'text-blue-600 bg-blue-100 p-2 rounded' : 'text-gray-700'}`}
                        onClick={() => setActiveComponent('Assessment')}
                    >
                        <i className="fas fa-file-alt mr-2"></i> Assessment
                    </li>
                    {/* <li
                        className={`mb-4 flex items-center cursor-pointer ${activeComponent === 'Setting' ? 'text-blue-600' : 'text-gray-700'}`}
                        onClick={() => setActiveComponent('Setting')}
                    >
                        <i className="fas fa-cog mr-2"></i> Setting
                    </li> */}
                    <li
                        onClick={handleLogoutClick}
                        className="flex items-center text-red-600 cursor-pointer"
                    >
                        <i className="fas fa-sign-out-alt mr-2"></i> Log out
                    </li>
                </ul>
            </nav>

            {/* Confirmation Dialog */}
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Logout"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to log out?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmLogout} color="primary" autoFocus>
                        Logout
                    </Button>
                </DialogActions>
            </Dialog>
        </aside>
    );
};

export default Sidebar;
